export const DISMISSED_RECOMMENDATIONS = 'dismissed_recommendations';
export const APPLIED_RECOMMENDATIONS = 'applied_recommendations';
export const DISMISS_LIMIT = 3;
export const SIMILAR_ORDERS_LIMIT = 3;
